// TODO:
// 1) Refactor events to remove duplicate code
// 3) Polish transitions
(function () {
  var windowWidth = window.innerWidth; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // Helper functions
  // () updateContainerHeight
  // Will update the tabs container to the height of the active item
  // and will clear the container height if in accordion mode

  var updateContainerHeight = function updateContainerHeight(group, item) {
    // if (windowWidth === window.innerWidth) return;
    var container = group.querySelector(".GroupedContent-container"),
        newHeight = window.innerWidth > 1 ? item.clientHeight + "px" : null;
    return container.style.height = newHeight;
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () updateAccordionHeight


  var updateAccordionHeight = function updateAccordionHeight(item) {
    var content = item.querySelector(".GroupedContent-single-content"),
        newHeight = window.innerWidth > 1 ? null : getItemHeight(item) + "px";
    return content.style.height = newHeight;
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () closest
  // Pure JS $.closest(), but operated differently
  // pass in the starting element `el` and a comparative function
  // suggested functions would be el.contains('class')


  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  }; // () debounce
  // Debounce function from:
  // https://davidwalsh.name/javascript-debounce-function
  // renamved vars to let/const and added arrow function... for consistency
  // besides the cosmetic tweaks the operation of the function is the same


  var debounce = function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
          args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }; // () getItemHeight
  // the evil function...
  // takes an item, removes the transitions, sets the height to `auto`
  // and grabs the correct item height, then resets everything to the way it was
  //
  // ...you just can't assign the new found height to the item immediately
  // without clashes happening. Perhaps a scoping or runtime issues?


  var getItemHeight = function getItemHeight(item) {
    item.style.transition = "none";
    item.style.height = "auto";
    var itemHeight = item.clientHeight;
    item.style.height = null;
    item.style.transition = null;
    return itemHeight;
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () registerAccordionEvents


  var registerAccordionEvents = function registerAccordionEvents(group, item) {
    var content = group.querySelectorAll(".GroupedContent-single");
    var allContent = group.querySelectorAll(".GroupedContent-single-content");
    var singleActive = closest(item, function (el) {
      return el.classList.contains("GroupedContent-single");
    });
    var singleActiveContent = singleActive.querySelector(".GroupedContent-single-content");

    var itemHeightFactory = function itemHeightFactory(content) {
      var height = getItemHeight(content);
      var heightResize = debounce(function () {
        if (windowWidth === window.innerWidth) return;
        return height = getItemHeight(content);
      }, 250);
      window.addEventListener("resize", heightResize);
      return function () {
        return height;
      };
    };

    var itemHeight = itemHeightFactory(singleActiveContent);

    var clickEvent = function clickEvent() {
      // Remove class from active item/nav item
      content.forEach(function (item) {
        return item.classList.remove("is-active");
      });
      allContent.forEach(function (item) {
        return item.style.height = "";
      });
      singleActive.classList.add("is-active");
      return singleActiveContent.style.height = itemHeight() + "px";
    };

    item.addEventListener("click", function (e) {
      e.preventDefault();
      return clickEvent();
    });
    var firstItem = document.querySelector(".GroupedContent-single");

    if (firstItem === singleActive) {
      clickEvent();
    }
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () updateAccordianHeight
  // const updateAccordianHeight = firstItem => {
  //     const content = firstItem.querySelector(
  //         ".GroupedContent-single-content"
  //     );
  //     const newHeight =
  //         window.innerWidth > 1 ? null : firstItem.clientHeight + "px";
  //     console.log(firstItem.clientHeight);
  // return (firstItem.style.height = newHeight);
  // newHeight = window.innerWidth > 1 ? item.clientHeight + "px" : null;
  // };
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () registerTabEvents


  var registerTabEvents = function registerTabEvents(group, item) {
    var content = group.querySelectorAll(".GroupedContent-single");
    var tabNav = group.querySelectorAll(".GroupedContent-nav > *");
    var singleActive = group.querySelector('.GroupedContent-single[data-content="' + item.dataset.content + '"]');
    item.addEventListener("click", function (e) {
      e.preventDefault(); // Remove class from active item/nav item

      content.forEach(function (item) {
        return item.classList.remove("is-active");
      });
      tabNav.forEach(function (item) {
        return item.classList.remove("is-active");
      }); // Add active class to nav item

      item.classList.add("is-active");
      singleActive.classList.add("is-active");
      return updateContainerHeight(group, singleActive);
    });
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // () initGroupContent


  var initGroupContent = function initGroupContent(group) {
    // The tab navigation
    var tabNav = group.querySelectorAll(".GroupedContent-nav > *");
    var accordionNav = group.querySelectorAll(".GroupedContent-single-title"); // This is fine for both tabs and accordions
    // it isn't beautiful, but not something I'll fix at this moment

    var firstItem = group.querySelector('.GroupedContent-single[data-content="' + tabNav[0].dataset.content + '"]');
    var containerUpdate = debounce(function () {
      return updateContainerHeight(group, firstItem);
    }, 250, true);
    window.addEventListener("resize", containerUpdate);
    tabNav.forEach(function (item) {
      return registerTabEvents(group, item);
    });
    accordionNav.forEach(function (item) {
      return registerAccordionEvents(group, item);
    });
    updateContainerHeight(group, firstItem);
    updateAccordionHeight(firstItem);
    return group;
  }; // - - - - - - - - - - - - - - - - - - - - - - - - - - - -


  var GroupedContent = document.querySelectorAll(".GroupedContent");
  return GroupedContent.forEach(initGroupContent);
})();